import React, { useState } from 'react';
import { FaChevronLeft } from "react-icons/fa";
import { getLogin } from '../Services/Operations/ProductAPI';
import { setAvature, setLoginData, setSignupData,setToken,setuserId } from '../Redux/user_information';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate} from 'react-router';

function Login() {
    const dispatch=useDispatch();
    const navigatate=useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({ email: '', password: '' });
    const BASE_URL = "https://zotpot.in";

    const handleLogin = async() => {
        let hasError = false;
        let errorMessages = { email: '', password: '' };

        if (!email) {
            errorMessages.email = 'Email is required';
            hasError = true;
        }

        if (!password) {
            errorMessages.password = 'Password is required';
            hasError = true;
        }

        setErrors(errorMessages);

        if (!hasError) {
            //console.log('Email:', email, 'Password:', password);
            try {
                const formData = new FormData();
                formData.append("email", email);
                formData.append("password", password);
                const response = await getLogin(formData);
                console.log("Login data : ",response)
    
                if (response.success === true) {
                    //console.log("response register: ", response);
                    dispatch(setLoginData({
                        response
                    }));
                    dispatch(setToken(response.data.auth_token));
                    dispatch(setuserId(response.data.id))
                    // const 
                    // console.log("image url : ",{BASE_URL}/assets/img/various/avatars/{response.data.avatar}.gif)
                    dispatch(setAvature(`${BASE_URL}/assets/img/various/avatars/${response.data.avatar}.gif`))
                    navigatate("/")
                }
            } catch (error) {
                console.error("Error fetching registration details:", error);
            }
        }
    };

    return (
        <div style={styles.container}>
            <div style={{ backgroundColor: "#decccc", padding: "20px" }}>
                <button className="back-button"><FaChevronLeft onClick={() => navigatate("/")}/></button>
                <h2 style={styles.heading}>LOGIN</h2>
                <p style={styles.subHeading}>Enter your email and password</p>
            </div>
            <div style={styles.formContainer}>
                <input
                    type="email"
                    placeholder="Email"
                    style={styles.input}
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        if (e.target.value) {
                            setErrors({ ...errors, email: '' });
                        }
                    }}
                />
                {errors.email && <p style={styles.errorText}>{errors.email}</p>}

                <input
                    type="password"
                    placeholder="Password"
                    style={styles.input}
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        if (e.target.value) {
                            setErrors({ ...errors, password: '' });
                        }
                    }}
                />
                {errors.password && <p style={styles.errorText}>{errors.password}</p>}

                <button onClick={handleLogin} style={styles.loginButton}>LOGIN</button>

                <div style={styles.registerSection}>
                    <p style={{ textAlign: "center" }}>Don't have an account yet? <a href="/register" style={styles.link}>Register</a></p>
                    <a href="/forgot-password" style={styles.forgotPassword}>Forgot Password?</a>
                </div>

                <div style={styles.languageSection}>
                    <p>Change Language</p>
                    <select style={styles.languageSelect}>
                        <option>English</option>
                    </select>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: "100%",
        maxWidth: "500px",
        margin: "auto",
    },
    backButton: {
        alignSelf: 'flex-start',
        marginBottom: '20px',
        fontSize: '24px',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
    },
    formContainer: {
        width: '81%',
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
    },
    heading: {
        fontSize: '24px',
        marginBottom: '10px',
    },
    subHeading: {
        fontSize: '16px',
        color: '#555',
        marginBottom: '20px',
    },
    input: {
        width: '100%',
        padding: '10px',
        marginBottom: '5px',
        borderRadius: '5px',
        border: '1px solid #ced4da',
        fontSize: '16px',
        outline: "none",
        backgroundColor: '#d8e7e9'
    },
    errorText: {
        color: 'red',
        fontSize: '14px',
        marginBottom: '10px',
    },
    loginButton: {
        width: '106%',
        padding: '10px',
        backgroundColor: '#ff7d00',
        color: '#fff',
        fontSize: '18px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginBottom: '20px',
        marginTop: "15px"
    },
    registerSection: {
        fontSize: '14px',
        marginBottom: '10px',
    },
    link: {
        color: '#ff7d00',
        textDecoration: 'none',
    },
    forgotPassword: {
        color: '#ff7d00',
        fontSize: '14px',
        textDecoration: 'none',
        display: 'block',
        marginTop: '10px',
        textAlign: "center",
    },
    languageSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '20px',
    },
    languageSelect: {
        padding: '5px',
        borderRadius: '5px',
        border: '1px solid #ccc',
    },
};

export default Login;
